const headerData = [{
		types: "selection",
		columnwidth: 50,
	},
	{
		prop: "Year",
		label: "年份",
		columnwidth: 100,
	},
	{
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 100,
	},
	{
		prop: "MFName",
		label: "生产厂商",
		columnwidth: 220,
	},
	{
		prop: "CompanyName",
		label: "平台名称",
		columnwidth: 220,
	},
	{
		prop: "FirstQuarterQuota",
		label: "第一季度指标",
		columnwidth: 130,
	},
	{
		prop: "SecondQuarterQuota",
		label: "第二季度指标",
		columnwidth: 130,
	},
	{
		prop: "ThirdQuarterQuota",
		label: "第三季度指标",
		columnwidth: 130,
	},
	{
		prop: "FourthQuarterQuota",
		label: "第四季度指标",
		columnwidth: 130,
	},
	{
		prop: "YearQuota",
		label: "年度指标",
		columnwidth: 130,
	},
	{
		prop: "CreatorName",
		label: "创建人",
		columnwidth: 155,
	},
	{
		prop: "CreateTime",
		label: "创建时间",
		columnwidth: 180,
	}
];
export default headerData;